import { apiClient } from './apiClient';

export const verificationService = {
  // Legacy CloudAuth flow — still mounted as fallback.
  async verify(certName: string, certNo: string, facePhoto: string) {
    return apiClient.post<{ passed: boolean; subCode: string }>('/api/v1/verification/verify', { certName, certNo, facePhoto });
  },

  // Alipay 实人认证 init: returns a QR/deep-link URL the user opens in their
  // Alipay app, plus the certifyId we use to poll the verdict.
  async initAlipayCertify(certName: string, certNo: string, returnUrl?: string) {
    return apiClient.post<{ certifyId: string; certifyUrl: string }>(
      '/api/v1/verification/init-alipay-certify',
      { certName, certNo, returnUrl },
    );
  },

  // Poll until passed=true or the user gives up. settled=false means still
  // in progress on Alipay's side; keep polling.
  async queryAlipayCertify(certifyId: string) {
    return apiClient.get<{ passed: boolean; settled: boolean; subCode?: string }>(
      `/api/v1/verification/alipay-certify-result/${encodeURIComponent(certifyId)}`,
    );
  },
};
